import {
  Datagrid,
  DateField,
  EditButton,
  EmailField,
  List,
  SelectInput,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';
import {USER_STATUS_CHOICES} from "../../constants/user-status";
import {StatusQuickEdit} from "./StatusQuickEdit";

const listFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    label="Status"
    choices={USER_STATUS_CHOICES}
    alwaysOn
  />,
];

export const UserList = () => (
  <List filters={listFilters}>
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source="id" />
      <EmailField source="email" />
      <TextField source="name" />
      <TextField source="lastName" />
      <StatusQuickEdit/>
      <DateField source="createdAt" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
);
